<script setup lang="ts">
import type { ContentBlock } from '../../types'

defineOptions({
  name: 'ContentBlocksItem',
})

interface Props {
  contentBlock: ContentBlock.Model
}

const props = defineProps<Props>()

const component = resolveComponent(props.contentBlock.component)
const isExist = computed<boolean>(() => typeof component !== 'string')

const componentProps = computed<Record<string, unknown>>(() => {
  const { data = {} } = props.contentBlock
  return Object.keys(data).reduce<Record<string, unknown>>((componentProps, itemKey) => {
    // Convert null value to undefined
    componentProps[itemKey] = data[itemKey] ?? undefined
    return componentProps
  }, {})
})
</script>

<template>
  <Component
    :is="component"
    v-if="isExist"
    v-bind="componentProps"
    :content-block-id="contentBlock.id"
  />
</template>
